import { gridRowIdSelector } from "@mui/x-data-grid-premium";
import type { GridRowModel, useGridApiRef } from "@mui/x-data-grid-premium";
import { useEffect } from "react";

const EMPTY_GRID_ROWS: GridRowModel[] = [];

/**
 * Bring back reactivity to the grid when cache is updated e.g. for status updates
 * Question asked to MUI for a better solution: https://github.com/mui/mui-x/issues/17550#issuecomment-2864827174
 */
const useReactiveUpdateDataGridRows = (
  apiRef: ReturnType<typeof useGridApiRef>,
  rows: GridRowModel[],
  loading: boolean
) => {
  const rowsForEffect = rows.length === 0 ? EMPTY_GRID_ROWS : rows;
  const rowsSignature = rowsForEffect.map((row) => String(row.id)).join("\0");

  useEffect(() => {
    const api = apiRef.current;
    if (!api?.updateRows || loading) {
      return;
    }

    // Only update rows already in the grid so lazy loading isn't disrupted
    const existingRows = rowsForEffect.filter(
      (row) => api.getRow(gridRowIdSelector(apiRef, row)) !== null
    );
    if (existingRows.length > 0) {
      api.updateRows(existingRows);
    }
  }, [rowsSignature, apiRef, loading, rowsForEffect]);
};

export { useReactiveUpdateDataGridRows };
